import SelectorBar from '@components/SelectorBar/SelectorBar';
import Layout from '@components/Layout/Layout';
import { SelectorBarAddNewPersonalCardButton } from './[cardId]/preview/components/SelectorBar';

import { Box } from '@ui-lib';
import { CardHeaderNav } from '../components/CardHeaderNav/CardHeaderNav';
import { ReactNode } from 'react';

interface LayoutProps {
  children: ReactNode;
}

// Everything inside /[workspace]/cards/personal/
export default function PersonalCardsLayout({ children }: LayoutProps): JSX.Element {
  return (
    <Layout title="Personal Cards">
      <CardHeaderNav />

      <Box display="flex" flexGrow={1}>
        <SelectorBar
          title="Cards"
          addNewButton={<SelectorBarAddNewPersonalCardButton id="add-personal-card-btn" />}
          mode="card"
        >
          <></>
        </SelectorBar>

        {children}
      </Box>
    </Layout>
  );
}
